import { enUS, es, it, Locale, pt, fr } from 'date-fns/locale';

export default function getLocale(locale: string): Locale {
  if (!locale)
    return pt;

  switch (locale.toLowerCase()) {
  case 'es':
    return es;
  case 'en':
    return enUS;
  case 'it':
    return it;
  case 'fr':
    return fr;
  default:
    return pt;
  }
}